const PAGE_STAGE = "Other"

const buildAnalyticsMetaDataFor = (tracking) => ({
  pageName: tracking.pageName,
  pageSection: tracking.pageSection,
  pageStage: PAGE_STAGE,
})


module.exports = {
  PAGE_STAGE,
  buildAnalyticsMetaDataFor
}
